export default __webpack_public_path__ + "media/images/react_icons/globe-bf215a0422f98c51da7e778c83860757.svg";